var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-popup',{staticClass:"image-preview",attrs:{"opened":_vm.isOpened()},on:{"close":function($event){return _vm.close()}}},[_c('div',[_c('img',{attrs:{"src":_vm.params().imageSrc,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }